import { render } from "./ShapePool.vue?vue&type=template&id=5aabd717&scoped=true&ts=true"
import script from "./ShapePool.vue?vue&type=script&lang=ts"
export * from "./ShapePool.vue?vue&type=script&lang=ts"

import "./ShapePool.vue?vue&type=style&index=0&id=5aabd717&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aabd717"]])

export default __exports__